import { useEffect, useState } from 'react';

const deriveSecondsRemaining = (target: number | null): number => {
  if (target === null) {
    return 0;
  }

  return Math.max(0, Math.ceil((target - Date.now()) / 1000));
};

export const useCountdownSeconds = (target: number | null): number => {
  const [seconds, setSeconds] = useState(() => deriveSecondsRemaining(target));

  const syncSecondsToTarget = (): void => {
    setSeconds(deriveSecondsRemaining(target));
  };

  useEffect(() => {
    syncSecondsToTarget();

    const intervalId: NodeJS.Timeout = setInterval(syncSecondsToTarget, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [target]);

  return seconds;
};